import { useTranslation } from "react-i18next";

import { useGetMainCategories, useGetParentCategories } from "../../apis";
import {
  CategoryList,
  MainCategoryModal,
  SubCategoryModal,
  SubChildCategoryModal
} from "../../components";
import { CategoryTypes } from "../../constants/enums";
import { useCategoriesNavigation } from "../../hooks";
import { CategoriesListsProps } from "./CategoriesLists.types";

import styles from "./CategoriesLists.module.scss";

const CategoriesLists = ({ isViewMode = false }: CategoriesListsProps) => {
  const { t } = useTranslation();
  const { mainCategoryId, subCategoryId } = useCategoriesNavigation();

  const categoriesLists = [
    {
      type: CategoryTypes.MAIN_CATEGORY,
      title: t("Categories"),
      useCategories: useGetMainCategories,
      CategoryModal: MainCategoryModal
    },
    {
      type: CategoryTypes.SUB_CATEGORY,
      title: t("Sub-categories"),
      isDisabled: !mainCategoryId,
      useCategories: () => useGetParentCategories(mainCategoryId),
      CategoryModal: SubCategoryModal
    },
    {
      type: CategoryTypes.SUB_CHILD_CATEGORY,
      title: t("Sub-sub-categories"),
      isDisabled: !subCategoryId,
      useCategories: () => useGetParentCategories(subCategoryId),
      CategoryModal: SubChildCategoryModal
    }
  ];

  return (
    <div className={styles["categories-lists"]}>
      {categoriesLists.map((item) => (
        <CategoryList key={item.type} {...item} isViewMode={isViewMode} />
      ))}
    </div>
  );
};

export default CategoriesLists;
